// extracted by mini-css-extract-plugin
module.exports = {"component":"skeleton-loader_component__4uMLz","shimmer":"skeleton-loader_shimmer__qCW_8"};